
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useNavigate } from "react-router-dom";

interface TokenDisplayProps {
  balance: number;
}

const TokenDisplay = ({ balance }: TokenDisplayProps) => {
  const navigate = useNavigate();
  const tokensPerType = balance / 5;

  const tokenTypes = [
    { name: "Curator", color: "bg-gray-300", textColor: "text-gray-700" },
    { name: "Contributor", color: "bg-red-500", textColor: "text-white" },
    { name: "Confirmer", color: "bg-green-500", textColor: "text-white" },
    { name: "Composer", color: "bg-black", textColor: "text-white" },
    { name: "Consumer", color: "bg-yellow-500", textColor: "text-black" },
  ];


  return (
    <Card className="p-6 bg-muted">
      <div className="space-y-4">
        <h3 className="font-serif text-lg font-semibold text-primary mb-4">OWL Token Balance</h3>
        <div className="grid gap-3">
          {tokenTypes.map((type) => (
            <div 
              key={type.name} 
              className="flex justify-between items-center"
            >
              <Badge 
                className={`${type.color} ${type.textColor} px-3 py-1`}
              >
                {type.name}
              </Badge>
              <span className="font-mono font-medium">{tokensPerType}</span>
            </div>
          ))}
        </div>
        <div className="pt-4 border-t">
          <div className="flex justify-between items-center">
            <span className="text-sm text-muted-foreground">Total Balance</span>
            <span className="font-bold">{balance}</span>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default TokenDisplay;
